// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2FBch","dragIcon":"SortableItem_dragIcon__3mnlQ","disabled":"SortableItem_disabled__3y_dV"};